import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  totalPendingAmount: 0,
  loading: false,
};

export const getBillList = createAsyncThunk(
  "get-bill",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("bill/list", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createBill = createAsyncThunk(
  "create-invoice",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("bill", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdBill = createAsyncThunk(
  "edit-bill",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`bill/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateBill = createAsyncThunk(
  "update-bill",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/bill/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateBillFlag = createAsyncThunk(
  "update-bill-flag",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/bill/flag/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteBill = createAsyncThunk(
  "delete-bill",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/bill/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const billSlice = createSlice({
  name: "bill",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBillList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBillList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.billList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
        state.totalPendingAmount =
          action?.payload?.data?.data?.totalPendingAmount ?? 0;
      })
      .addCase(getBillList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default billSlice.reducer;
